import * as React from 'react';
import { CLASSNAME_PREFIX } from './componentConfig';
import './VerificationJourney.scss';
import { Scenarios } from '@account-verification-frontend/scenarios-container';
import { Header } from '@account-verification-frontend/header';
function VerificationJourney() {
    return (React.createElement("div", { className: CLASSNAME_PREFIX + "-component" },
        React.createElement(Header, null),
        React.createElement(Scenarios, null)));
}
export default VerificationJourney;
//# sourceMappingURL=VerificationJourney.js.map